import { useState, useEffect } from 'react';

export function useStatamicContent(endpoint, options = {}) {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchData = async () => {
      try {
        setLoading(true);
        const url = `/api/${endpoint}${options.params ? `?${new URLSearchParams(options.params)}` : ''}`;
        
        const response = await fetch(url, {
          headers: options.headers || {},
          cache: options.cache || 'default'
        });
        
        if (!response.ok) {
          throw new Error(`API Error: ${response.status} ${response.statusText}`);
        }
        
        setData(await response.json());
        setError(null);
      } catch (err) {
        setError(err.message);
        console.error('Statamic API Error:', err);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, [endpoint, JSON.stringify(options)]);

  return { data, loading, error };
}